var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-breadcrumb" },
    [
      _c(
        "ul",
        { staticStyle: { display: "flex", "align-items": "center" } },
        [
          _c("li", [
            _c(
              "div",
              {
                staticClass: "item",
                on: {
                  click: function ($event) {
                    return _vm.chatMainMenu("/")
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.home")) +
                    "\n            "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm.doesRouteHasIntegrations
              ? _c(
                  "div",
                  {
                    staticClass: "item integration",
                    class: { "last-item": _vm.isIntegrationLastItem },
                    on: {
                      click: function ($event) {
                        return _vm.go("/integrations")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.integrations")) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.taskRouteHas
            ? _c("li", [
                _c(
                  "div",
                  {
                    staticClass: "item tasks",
                    class: { "last-item": _vm.isTasksLastItem },
                    on: { click: _vm.workflowList },
                  },
                  [_vm._v("\n                Tasks\n            ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.paths
            ? _vm._l(_vm.paths, function (item, index) {
                return _c(
                  "li",
                  {
                    key: "br-" + index,
                    staticClass: "d-flex align-items-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "item sec",
                        class: { "last-item": index === _vm.paths.length - 1 },
                        attrs: { colorize: "c-" + index },
                        on: {
                          click: function ($event) {
                            item.path === "chat"
                              ? _vm.chatMainMenu(item.path)
                              : _vm.go(item.path)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.title) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showSubjects
            ? _c("li", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedSubjectModel,
                        expression: "selectedSubjectModel",
                      },
                    ],
                    attrs: { id: "departSelect" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedSubjectModel = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "null" } }, [
                      _vm._v(_vm._s(_vm.$t("message.allDepartments"))),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.subjects, function (subject) {
                      return _c(
                        "option",
                        { key: subject._id, domProps: { value: subject._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.getSubjectName(subject)) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.select
            ? _c(
                "li",
                { staticClass: "d-flex align-items-center" },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("li", { staticClass: "ml-auto" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _vm.showTrialRemainDay &&
                _vm.trialInfo.trial &&
                _vm.settings &&
                _vm.settings.plan
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                              theme: _vm.isDarkMode ? "light-border" : "google",
                            },
                            expression:
                              "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                          },
                        ],
                        staticClass: "item four mr-2 ml-2",
                        staticStyle: {
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                          display: "-webkit-box",
                          "-webkit-box-orient": "vertical",
                          "-webkit-line-clamp": "1",
                          "word-break": "break-all",
                        },
                        attrs: {
                          content: _vm.$t("billing.trialTimeInformation", {
                            dayCount: _vm.trialInfo.remainingDays,
                          }),
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "text-info bold",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push("/settings/billing")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("billing.trialTimeInformationShort", {
                                    dayCount: _vm.trialInfo.remainingDays,
                                  })
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.customerDomainsFetched && !_vm.isSiteIntegrated()
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                              theme: _vm.isDarkMode ? "light-border" : "google",
                            },
                            expression:
                              "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                          },
                        ],
                        staticClass: "actionButtonBreadcrumb",
                        attrs: { content: _vm.$t("message.notIntegratedDesc") },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.integrationInstruction.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _c("md-icon", { staticStyle: { color: "red" } }, [
                          _vm._v("support"),
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.notIntegrated")) +
                            "\n                "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.activeBroadcast
            ? _c(
                "li",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                        theme: _vm.isDarkMode ? "light-border" : "google",
                      },
                      expression:
                        "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
                    },
                  ],
                  staticClass: "active-broadcast-item",
                  attrs: { content: _vm.getActiveBroadcastTooltip() },
                  on: { click: _vm.goToActiveBroadcast },
                },
                [
                  _c("div", { staticClass: "active-broadcast-content" }, [
                    _c(
                      "span",
                      { staticClass: "material-icons broadcast-icon" },
                      [_vm._v("podcasts")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "broadcast-label" }, [
                      _vm._v("Toplu Mesaj:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "broadcast-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.truncateBroadcastTitle(_vm.activeBroadcast.title)
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "broadcast-progress" }, [
                      _vm._v(
                        _vm._s(_vm.getBroadcastPercent(_vm.activeBroadcast)) +
                          "%"
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.largeHeader
            ? _c(
                "li",
                [
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                        },
                      ],
                      staticClass:
                        "actionButtonBreadcrumb m-0 w-100 act-btn wifi-status-button",
                      staticStyle: { "min-width": "20px", "max-width": "25px" },
                      attrs: {
                        content: _vm.socketConnected
                          ? _vm.$t("message.connectServer")
                          : _vm.$t("message.disconnectServer"),
                      },
                      on: { click: _vm.disconnectSocket },
                    },
                    [
                      _c(
                        "div",
                        { class: { blinkAnimation: !_vm.socketConnected } },
                        [
                          _c("WifiIcon", {
                            staticClass: "wifi-icon",
                            attrs: {
                              color: _vm.socketConnected ? "#25CC52" : "red",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("li", [_c("ChatbotStatusWidget")], 1),
          _vm._v(" "),
          _c("li", [
            _c(
              "div",
              {
                staticClass: "storage-information-item",
                attrs: { leftPercentTile: _vm.getStorageStatus() },
                on: {
                  mouseenter: function ($event) {
                    _vm.storageIconHovered = true
                  },
                  mouseleave: function ($event) {
                    _vm.storageIconHovered = false
                  },
                },
              },
              [
                _c("StorageIcon", {
                  staticClass: "storage-icon",
                  attrs: {
                    color: _vm.storageIconHovered
                      ? _vm.getStorageStatus() === "high"
                        ? "rgb(111, 200, 98)"
                        : _vm.getStorageStatus() === "medium"
                        ? "rgb(0, 164, 255)"
                        : "rgb(168, 40, 40)"
                      : "#3A3F48",
                  },
                }),
                _vm._v(" "),
                _vm.storageIconHovered
                  ? _c("div", {
                      staticClass: "custom-tooltip",
                      domProps: {
                        innerHTML: _vm._s(_vm.storageTooltipContent),
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.voiceAgentChannelExists ? _c("li", [_vm._m(0)], 1) : _vm._e(),
          _vm._v(" "),
          _vm.largeHeader && _vm.telegramBotEnabled
            ? _c(
                "li",
                {
                  on: {
                    mouseenter: function ($event) {
                      _vm.telegramIconHovered = true
                    },
                    mouseleave: function ($event) {
                      _vm.telegramIconHovered = false
                    },
                  },
                },
                [
                  _c(
                    "md-button",
                    {
                      staticClass:
                        "actionButtonBreadcrumb m-0 wp-btn telegram-status-button",
                      staticStyle: { "min-width": "20px", "max-width": "25px" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push("/integrations")
                        },
                      },
                    },
                    [
                      _c("TelegramIcon", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                              theme: _vm.isDarkMode ? "light-border" : "google",
                            },
                            expression:
                              "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                          },
                        ],
                        staticClass: "telegram-icon",
                        attrs: {
                          color: _vm.telegramIconHovered
                            ? !_vm.telegramBotInfo.initialized
                              ? "gray"
                              : _vm.telegramServiceIsHealthy
                              ? "green"
                              : "#e24444"
                            : "#3A3F48",
                          content: !_vm.telegramBotInfo.initialized
                            ? _vm.$t("message.telegramBotIsReachable")
                            : _vm.telegramServiceIsHealthy
                            ? _vm.$t("message.telegramBotIsHealthy")
                            : _vm.$t("message.telegramBotIsUnhealthy"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.whatsappChannelExists
            ? _c("li", [_c("ChannelsStatus")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.igChannelExists
            ? _c("li", [_c("IGChannelsStatus")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.messengerChannelExists
            ? _c("li", [_c("MessengerChannelStatusWidget")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.channelSmsVisable
            ? _c("li", [_c("ChannelStatusPostaCell")], 1)
            : _vm._e(),
          _vm._v(" "),
          _vm.largeHeader
            ? _c(
                "li",
                {
                  staticClass: "agent-status-li",
                  on: {
                    mouseenter: function ($event) {
                      _vm.agentIconHovered = true
                    },
                    mouseleave: function ($event) {
                      _vm.agentIconHovered = false
                    },
                  },
                },
                [
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                            theme: _vm.isDarkMode ? "light-border" : "google",
                          },
                          expression:
                            "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                        },
                      ],
                      staticClass:
                        "actionButtonBreadcrumb m-0 act-btn agent-status-button",
                      staticStyle: { "min-width": "20px", "max-width": "25px" },
                      attrs: {
                        content: _vm.offlineMode
                          ? _vm.$t("message.liveChatOff")
                          : _vm.$t("message.liveChatOn"),
                      },
                    },
                    [
                      _c("AgentIcon", {
                        staticClass: "agent-icon",
                        attrs: {
                          color: _vm.agentIconHovered
                            ? _vm.offlineMode
                              ? "red"
                              : "green"
                            : "#3A3F48",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.$route.path === "/chat" || _vm.$route.query.tab === "inbox") &&
          _vm.$_.get(_vm.wallet, "whatsapp.amount")
            ? _c(
                "li",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                        theme: _vm.isDarkMode ? "light-border" : "google",
                      },
                      expression:
                        "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
                    },
                  ],
                  staticClass: "wallet-balance-item",
                  attrs: {
                    content:
                      "Cüzdan Bakiyeniz: " +
                      _vm.seperateWithCommas(
                        _vm.wallet.whatsapp.amount.toFixed(2)
                      ) +
                      "₺",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/settings/wallet")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "wallet-balance-content",
                      class: {
                        "negative-balance": _vm.wallet.whatsapp.amount < 0,
                        "low-balance":
                          _vm.wallet.whatsapp.amount >= 0 &&
                          _vm.wallet.whatsapp.amount < 200,
                      },
                    },
                    [
                      _c("MoneyFormatter", {
                        attrs: {
                          price: _vm.wallet.whatsapp.amount,
                          className: "wallet-amount",
                        },
                      }),
                      _vm._v(" "),
                      _c("WalletIcon", {
                        staticClass: "wallet-icon",
                        attrs: {
                          color:
                            _vm.wallet.whatsapp.amount < 0
                              ? "#FF2525"
                              : _vm.wallet.whatsapp.amount < 200
                              ? "#FFA800"
                              : "#25CC52",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.largeHeader ? _c("li", [_c("WebTabButton")], 1) : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.largeHeader ? _c("HeaderRight") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("VoiceAgentChannelStatusWidget")
  },
]
render._withStripped = true

export { render, staticRenderFns }